<template>
  <v-row class="mx-0"
         :class="backgroundColor"
         style="position: relative; top: -12px; height: calc(100% + 36px)"
         :style="{
           borderRight: areFiltersShown ? '1px solid rgba(0, 0, 0, 0.18)!important' : ''
         }">
    <v-col class="pr-0" cols="12" v-show="areFiltersShown">
      <span class="d-block kbDarkBlueText--text pt-3"
            style="font-size: 20px">
        {{ $t('general.peopleFilters') }}
      </span>
      <v-card class="pt-3 pr-2" flat style="background-color: transparent!important;">
        <v-card-text class="px-0 pb-0 filters-card-text"
                     :class="`${menuLocation}-filters`">
          <PeopleFilters @openPeopleFilters="openPeopleFilters()" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import PeopleFilters from '@/pages/App/People/Filters/PeopleFilters'
import { mapState } from 'vuex'
export default {
  components: { PeopleFilters },
  computed: {
    ...mapState({
      menuLocation: state => state.graphicAspect.menuLocation
    }),
    backgroundColor () {
      let backgroundColor = 'kbLightGray'
      if (this.$vuetify.theme.isDark) {
        backgroundColor = 'kbWhite'
      }
      if (!this.areFiltersShown) {
        backgroundColor = 'kbGray'
      }
      return backgroundColor
    }
  },
  methods: {
    openPeopleFilters () {
      this.$emit('openPeopleFilters')
    }
  },
  props: {
    areFiltersShown: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.filters-card-text {
  max-height: calc(98vh - 230px)!important;
  overflow-y: auto;
}
@media (min-width: 1264px) {
  .filters-card-text.sidebar-filters {
    max-height: 65vh;
  }
  .filters-card-text.toolbar-filters {
    max-height: 76vh;
  }
}
@media (min-width: 1904px) {
  .filters-card-text.sidebar-filters {
    max-height: 72vh;
  }
  .filters-card-text.toolbar-filters {
    max-height: 80vh;
  }
}
</style>
